// extracted by mini-css-extract-plugin
module.exports = {"cell":"styles_cell__zld_J","skeleton":"styles_skeleton__1a4sR","totalCell":"styles_totalCell__8E6Vz","isTotal":"styles_isTotal__3Fqdm"};